module.exports = __webpack_public_path__ + "img/xuanxiang.63ef74d9.png";